module.exports = __webpack_public_path__ + "static/media/text.5c25d95e.png";